import CalendarHeatmap from "components/dashboard/calendar-heatmap/CalendarHeatmap";
import { MdmObjectDto } from "gql/generated/types";
import React from "react";
import { TableColumn } from "utils/types";
import { useGetDataInfoRange } from "api/api-hooks/datasets-hooks";
import CalendarWrapper from "components/basic/calendar-wrapper/CalendarWrapper";
import ItemsTable from "./ItemsTable";

type ObjectAnalyticsProps = {
  object: MdmObjectDto
}

const ObjectAnalytics: React.FC<ObjectAnalyticsProps> = ({ object }) => {
  const sevenDaysAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
  sevenDaysAgo.setHours(0, 0, 0, 0);
  const [dateFrom, setDateFrom] = React.useState<Date>(sevenDaysAgo);
  const [dateTo, setDateTo] = React.useState<Date>(new Date());
  const columns: TableColumn<any>[] = [
    { field: "date", header: "Date", sortable: true, filter: true, body: rowData => new Date(rowData.date).toLocaleString() },
    { field: "analyticsType", header: "Type", sortable: true, filter: true },
    { field: "description", header: "Description"},
  ];

  const { data, isLoading } = useGetDataInfoRange(["28653:CATEGORIZED_DATASET"], {
    timeStart: dateFrom?.toISOString(),
    timeEnd: dateTo?.toISOString(),
  });

  const mapData = data?.[0].data.reduce((arr: Array<any>, item: any) => {
    if (item.value >= 70) {
      arr.push({
        date: item.key,
        analyticsType: "High Value",
        description: `dataset reach high value ${item.value}`,
      });
    }
    return arr;
  }, []);

  return (
    <div>
      <div className="flex gap-2 mb-5 z">
        <div className="flex flex-column gap-2">
          <label>Date from:</label>
          <CalendarWrapper value={dateFrom} showTime={false} onChange={date => setDateFrom(date)} />
        </div>
        <div className="flex flex-column gap-2">
          <label>Date to:</label>
          <CalendarWrapper value={dateTo} showTime={false} onChange={date => setDateTo(date)} />
        </div>
      </div>
      <CalendarHeatmap
        startDate={dateFrom}
        endDate={dateTo}
        identifier="28653:CATEGORIZED_DATASET"
        highValueColor="ed0000"
        lowValueColor="ffffff"
        maxValue={10}
        minValue={0}
        lowValueTitle="cccc"
        highValueTitle="wwww"
        showDateSelection={false}
        staticMinMaxColors
        staticMinMaxTitles={false}
        staticMinMaxValues
      />
      {mapData && mapData?.length > 0 && (
        <ItemsTable
          columns={columns}
          data={mapData}
          isLoading={isLoading}
          showToolbar={false}
        />
      )}
    </div>
  );
}

export default ObjectAnalytics;